import { ReportsApiParamsTypes } from 'types';
import { action } from 'typesafe-actions';
import { ReportsActionTypes } from './types';

export const fetchReports = (request?: any) =>
  action(ReportsActionTypes.FETCH_REPORTS, request);

export const fetchReportsSuccess = (data: any) =>
  action(ReportsActionTypes.FETCH_REPORTS_SUCCESS, data);

export const fetchReportsFailure = (error: any) =>
  action(ReportsActionTypes.FETCH_REPORTS_FAILURE, error);

export const setReportTokenAndTypes = (data: any) =>
  action(ReportsActionTypes.SET_REPORT_TOKEN_TYPES, data);

export const setReportTokenSuccess = (token: any) =>
  action(ReportsActionTypes.SET_REPORT_TOKEN_SUCCESS, token);

export const setReportTokenFailure = (error: any) =>
  action(ReportsActionTypes.SET_REPORT_TOKEN_FAILURE, error);

export const setReportTypesSuccess = (data: any) =>
  action(ReportsActionTypes.SET_REPORT_TYPES_SUCCESS, data);

export const setReportTypesFailure = (error: any) =>
  action(ReportsActionTypes.SET_REPORT_TYPES_FAILURE, error);

export const fetchReportFiltesRequest = (payload: ReportsApiParamsTypes) =>
  action(ReportsActionTypes.FETCH_REPORT_FILTERS_REQUEST, payload);

export const fetchReportFiltesSuccess = (data: any) =>
  action(ReportsActionTypes.FETCH_REPORT_FILTERS_SUCCESS, data);

export const fetchReportFiltersFailure = (error: any) =>
  action(ReportsActionTypes.FETCH_REPORT_FILTERS_FAILURE, error);

export const cleanReportsState = () =>
  action(ReportsActionTypes.SET_REPORTS_INITIAL_STATE);
